module.exports = "pegasus/assets/tech-logo.png";